
























import { Component, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import HasValidation from "@/mixins/HasValidation";
import LoggedUserMixin from "@/mixins/loggedUserMixin";
import { ILanguage } from "@/models/constants";
import SupportedLocaleCodes from "@/locales";
import _ from "@/boot/lodash";

interface Form {
  name: string;
  phone: string;
  phone_code: string;
  phone_country_code: string;
  interface_language_code: ILanguage["code"];
  document_language_code: ILanguage["code"];
}

const initialForm = (): Form => {
  return {
    name: "",
    phone: "",
    phone_code: "",
    phone_country_code: "",
    interface_language_code: SupportedLocaleCodes.EN,
    document_language_code: SupportedLocaleCodes.EN
  };
};

@Component({
  components: {
    "user-fields": () => import("@/components/app/admin/users/userFields.vue")
  }
})
export default class MyProfileForm extends Mixins(
  RequestPromises,
  LoggedUserMixin,
  HasValidation
) {
  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  public isProcessing = false;

  public async created() {
    this.initForms();
  }

  public async validateBeforeSubmit() {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.save();
      this.initialForm = _.cloneDeep(this.form);
      this.$buefy.toast.open({
        message: this.$t("_sentence.successfully_saved") as string
      });

      this.$store.dispatch("auth/admin/getUser");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public save() {
    this.form.document_language_code = this.form.interface_language_code;
    return this.$store.dispatch(`data/${DataModules.USERS}/update`, {
      id: this.loggedUser.id,
      data: this.formValues
    });
  }

  public revertToInitialState() {
    this.form = _.cloneDeep(this.initialForm);
  }

  public get isFormChanged(): boolean {
    return _.isEqual(this.form, this.initialForm);
  }

  public initForms() {
    this.form = _.pick(this.loggedUser, [
      "name",
      "email",
      "phone",
      "phone_code",
      "phone_country_code",
      "interface_language_code",
      "document_language_code"
    ]);
    this.$set(this, "initialForm", _.clone(this.form));
  }

  public get formValues() {
    const newValues: any = _.omitBy(this.form, (v, k) => {
      return this.initialForm[k] === v;
    });

    return newValues;
  }
}
